export default function Configure($stateProvider) {
	$stateProvider.state('regroupement-sites', {
		parent: 'gestion',
		url: '/regroupement-sites',
		views: {
			gestion: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			label: '{{ "LAYOUT.NAVIGATION.STOCKS" | translate }}'
		}
	});

	$stateProvider.state('regroupement-sites.list', {
		url: '/list',
		template: '<regroupement-sites></regroupement-sites>',
		rights: { domain: 'stockconfigrs', right: 'read' },
		ncyBreadcrumb: {
			label: '{{ "STOCKS.BREADCRUMBS.REGROUPEMENT_SITES" | translate }}'
		},
		navigation: {
			menu: 'stocks_configuration',
			translate: 'STOCKS.BREADCRUMBS.REGROUPEMENT_SITES',
			order: 3
		},
		search: 'STOCKS.BREADCRUMBS.REGROUPEMENT_SITES'
	});
}

Configure.$inject = ['$stateProvider'];
